import * as React from 'react';
import BaseComponent from '../BaseComponent';
import {Button, Card, CardBody, CardHeader, Col, Modal, Row} from "reactstrap";
import * as PropTypes from 'prop-types';
// import label from "../../message/Label"
import label from 'enqc-utilities/src/label/Label'

import inspectionImage from '../../assets/img/banner/inspection.png'
import HorizontalLine from "../Widget/HorizontalLine";
import MyCardImage from "../Card/MyCardImage";
import WarningLabel from "../Widget/WarningLabel";
import ModalCardHeader from "../Widget/ModalCardHeader";

/*= (message, okCallback, cancelCallback) =>*/
export default class CreateInspectionConfirmModal extends BaseComponent{

    constructor(props){
        super(props);
        let {assembly} = this.props
        if(!assembly){
            assembly = {}
        }
        this.state = {
            assembly,
            referenceCode:undefined,
            errorMessage:undefined,
        }
    }
    componentWillReceiveProps(props, nextContext) {
        if(this.props!==props){
            let {assembly} = props
            if(!assembly){
                assembly = {}
            }
            this.setState({
                assembly,
                referenceCode:undefined,
                errorMessage:undefined,
            })
        }
    }


    render(){
        let {assembly, referenceCode, errorMessage} = this.state
        let {onClickOk, onClickCancel} = this.props
        if(!onClickOk){
            onClickOk = () => {}
        }
        if(!onClickCancel){
            onClickCancel = () => {}
        }

        let model = assembly.model?assembly.model:{}
        return (
            <>
                {super.render()}
                <Modal
                    autoFocus={false}
                    size="md"
                    centered={true}
                    isOpen={this.props.show}
                    backdrop={true}>
                    <Card style={{textAlign:'center'}}>
                        <ModalCardHeader content={<span className="h1 text-uppercase">{label.InspectionCreation}</span>}/>
                        <CardBody>
                            <Row>
                                <Col>
                                    <MyCardImage style={{padding:'32px', width:'80%'}} src={inspectionImage}/>
                                </Col>
                            </Row>
                            <HorizontalLine/>
                            <Row>
                                <Col>
                                    <h3>
                                        <strong>
                                            {model.systemType}
                                        </strong>
                                    </h3>
                                    <br/>
                                    <span>{label.Reference}</span>
                                    <h2 className="text-primary bold"><strong>{assembly.reference}</strong></h2>
                                    <WarningLabel message={errorMessage} show={errorMessage!=undefined}/>
                                    <br/>
                                    <strong style={{color:'brown'}}>
                                        {label.DoYouWantToCreateNewInspectionBasedOnTheAssemblyReferenceCodeAbove}
                                    </strong>
                                </Col>
                            </Row>
                            <HorizontalLine/>
                            <Row>
                                <Col style={{textAlign:'left'}}>
                                    <Button
                                        block
                                        color={"danger"}
                                        onClick={() => {
                                            onClickCancel()
                                        }}>
                                        {label.Cancel}
                                    </Button>
                                </Col>
                                <Col style={{textAlign:'right'}}>
                                    <Button
                                        block
                                        onClick={() => {
                                            onClickOk(assembly)
                                            // this.validateReference(referenceCode, true)
                                        }}>
                                        {label.CreateNewInspection}
                                    </Button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Modal>
            </>
           )
    }
}

CreateInspectionConfirmModal.propTypes = {
    assembly:PropTypes.any.isRequired,
    show:PropTypes.bool.isRequired,
    onClickOk:PropTypes.func.isRequired,
    onClickCancel:PropTypes.func.isRequired,
}
